/// <amd-module name="TFS/Security/Common/Constants" />
export const EnableExportPermissionsPanelFF = "VisualStudio.Services.AdminEngagement.ResourcePermissions.EnableExportPermissionsOnPanel";

export const EnableExportPermissionsFF = "VisualStudio.Services.AdminEngagement.ResourcePermissions.EnableExportPermissions";
